/** @jsxImportSource @emotion/react */

import {
  Checkbox,
  ListItem,
  Modal,
  Typography,
  useTheme,
} from '@quickbit/qb-design-system';
import { useState } from 'react';

interface Props {
  onCreate: (includeIncomplete: boolean) => void;
  onCancel: () => void;
  from: Date | null;
  to: Date | null;
  isDownloading: boolean;
}

const getDisplayDate = (date: Date) => date.toLocaleDateString();

export const DownloadModal = ({
  onCreate,
  onCancel,
  from,
  to,
  isDownloading,
}: Props) => {
  const { sizing, palette, shape, spacing } = useTheme();
  const [includeIncomplete, setIncludeIncomplete] = useState(false);

  const dateDisplayString =
    from && to
      ? `${getDisplayDate(from)} to ${getDisplayDate(to)}`
      : from && !to
        ? `${getDisplayDate(from)} to Now`
        : 'All time';

  return (
    <Modal
      title="Download report"
      primaryButtonProps={{
        text: 'Download',
        onClick: () => {
          onCreate(includeIncomplete);
        },
        disabled: isDownloading,
        loading: isDownloading,
      }}
      secondaryButtonProps={{ text: 'Cancel', onClick: onCancel }}
      closeModal={onCancel}
    >
      <div
        css={{
          maxWidth: sizing.small,
          display: 'flex',
          flexDirection: 'column',
          gap: spacing.xs,
        }}
      >
        <Typography variant="bodySmall">
          This will create a report based on the current selection of filters,
          including both the aggregated data and each individual transactions.
        </Typography>
        <Typography variant="bodySmallest">
          If you choose to include incomplete orders, the report display the
          creation date of the order, otherwise the report will display the
          completion date of the order.
        </Typography>
        <div
          css={{
            border: `1px solid ${palette.grey.x100}`,
            borderRadius: shape.borderRadius,
            position: 'relative',
          }}
        >
          <ListItem
            title="Include incomplete orders"
            subtitle={dateDisplayString}
            action={<Checkbox checked={includeIncomplete} />}
            onClick={() => {
              setIncludeIncomplete((prev) => !prev);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
